var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.layout
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    class: _vm.theme.content
  }, [_c('app-bar'), _vm._v(" "), _c('bread-crumbs'), _vm._v(" "), _c('navigation-tabs'), _vm._v(" "), (_vm.profile.notifications) ? _c('div', _vm._l((_vm.profile.notifications), function(notification, index) {
    return _c('div', {
      directives: [{
        name: "padding",
        rawName: "v-padding",
        value: (5),
        expression: "5"
      }],
      key: index,
      class: _vm.theme.infoBlock
    }, [_c('div', {
      directives: [{
        name: "margin",
        rawName: "v-margin.right",
        value: (4),
        expression: "4",
        modifiers: {
          "right": true
        }
      }],
      class: ((_vm.theme.blockIcon) + " " + (_vm.theme.blockIcon__info))
    }, [_c('v-font-icon', {
      attrs: {
        "white": "",
        "regular": ""
      }
    }, [_vm._v("\n                        info\n                        ")])], 1), _vm._v(" "), _c('v-text', {
      attrs: {
        "secondary": "",
        "type": "subheadling"
      }
    }, [_vm._v("\n                        " + _vm._s(notification) + "\n                    ")])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.tariff && (_vm.tariff.daysLeft <= 10 && !_vm.tariff.hasInactivePackages)) ? _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (5),
      expression: "5"
    }],
    class: _vm.theme.infoBlock
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.right",
      value: (4),
      expression: "4",
      modifiers: {
        "right": true
      }
    }],
    class: ((_vm.theme.blockIcon) + " " + (_vm.theme.blockIcon__info))
  }, [_c('v-font-icon', {
    attrs: {
      "white": "",
      "regular": ""
    }
  }, [_vm._v("\n                        notifications_none\n                    ")])], 1), _vm._v(" "), _c('v-text', {
    attrs: {
      "secondary": "",
      "type": "subheadling"
    }
  }, [(_vm.profile.contactFIO) ? _c('span', {
    attrs: {
      "secondary": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.profile.contactFIO) + ", напоминаем об истечении срока действия тарифа."), _c('br')]) : _c('span', {
    attrs: {
      "secondary": ""
    }
  }, [_vm._v("\n                        Напоминаем об истечении срока действия тарифа."), _c('br')]), _vm._v("\n                    Тариф действует до " + _vm._s(new Date(_vm.tariff.endDate).toLocaleDateString("ru-RU")) + ".\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.theme.content
  }, [_c('div', {
    class: _vm.theme.container
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('app-footer')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29de23f8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/HomeLayout/HomeLayout.vue
// module id = 1204
// module chunks = 0